//useMyQuizSelection.ts
/*
//MyQuizeSelectionサービス
*/

import useSWR, { mutate } from 'swr';
import { doc, getDoc } from 'firebase/firestore';
import { MyQuizSelection } from '../types';
import { db, appId } from '../firebase';
import { fetchMyQuizSelection } from '../services/myQuizSelectionService';


/**
 *  MyQuizSelectionを取得
 * @param userId 
 * @returns   
 */
export function useMyQuizSelection(userId: string) {
  const key = userId ? `/my-quiz-selection/${userId}` : null;
  const {
    data: myQuizSelection,
    error,
    isLoading,
    mutate,
  } = useSWR(key, () => fetchMyQuizSelection(userId));

  return {
    myQuizSelection,
    isLoading,
    isError: error,
    mutate,
  };
}